export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "formalized_active_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formalizados"])},
          "not_formalized_active_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No formalizados"])},
          "inactive_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactivos"])},
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "total_hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hectáreas"])},
          "total_square_meters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["m²"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "download_producers_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar productores"])},
          "download_crop_fields_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar productores y campos"])},
          "new_producer_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir productor"])},
          "no_producers_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se encontraron productores"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])}
        }
      }
    }
  })
}